"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";

const images = [
  {
    src: "/images/carousel/carousel_1.webp",
    alt: "Songs Row 1",
    width: 4000,
    height: 1000,
  },
  {
    src: "/images/carousel/carousel_2.webp",
    alt: "Songs Row 2",
    width: 4000,
    height: 1000,
  },
];

export default function ImageCarousel() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <div className="w-full my-10">
      {images.map((image, index) => {
        // shorter duration on small screens, slightly offset per row
        const duration = isSmallScreen ? 20 + index * 5 : 100 + index * 5;

        return (
          <div key={index} className="overflow-hidden w-full mb-8">
            <div
              className={`flex ${
                index % 2 === 0 ? "animate-scroll" : "animate-scroll-reverse"
              }`}
              style={{ animationDuration: `${duration}s` }}
            >
              {/* Original image */}
              <div className="flex-shrink-0 min-w-full h-48 relative">
                <Image
                  src={image.src}
                  alt={image.alt}
                  fill
                  className="object-cover"
                  quality={100}
                  priority={index === 0}
                  unoptimized
                />
              </div>
              {/* Duplicate for seamless looping */}
              <div className="flex-shrink-0 min-w-full h-48 relative">
                <Image
                  src={image.src}
                  alt={image.alt}
                  fill
                  className="object-cover"
                  quality={100}
                  unoptimized
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
